import React from 'react';
import "../../css/tableStyles.css";

const FlexRow = (props) => {
    if(props.item["Recommended Action"] !== "N/A") {
        return (
            <div className="flexRow rowmain rowWrap">
                <div className="flexCell">{props.item.Location}</div>
                <div className="flexCell">{props.item.Notes}</div>
                <div className="flexCell"><span className="dataorigin ieq"></span>{props.item["Date Issued"]}</div>

                <div className="extratext">
                    <div>
                        <strong>Recomended action: </strong>{props.item["Recommended Action"]}
                    </div>
                    <div>
                        <strong>Issue status: </strong>{props.item['Issue status']}
                    </div>
                </div>
            </div>
        )
        } else {
            return (
                <div className="flexRow rowmain rowWrap">
                    <div className="flexCell">{props.item.Location}</div>
                    <div className="flexCell">{props.item.Notes}</div>
                    <div className="flexCell"><span className="dataorigin sms"></span>{props.item["Date Issued"]}</div>
                </div>
            )
        }

}


                            // const FlexRow = (props) => {
                            //     return (<div className="flexRow rowWrap">
                            //         <div className="flexCell fourCols">{props.item.Location}, Floor {props.item.Floor}</div>
                            //         <div className="flexCell fourCols">{props.item.Material_Description}</div>
                            //         <div className="flexCell fourCols">{props.item.Amount_of_damage}</div>
                            //         <div className="flexCell fourCols">{props.item.Priority}</div>
                            //
                            //     </div>)
                            // }
                            //
                            //
                            // class FlexRow extends Component {
                            //     constructor(props) {
                            //         super(props);
                            //         // this.state = {
                            //         //     clicked: true
                            //         // }
                            //
                            //         // this.testclick = this.testclick.bind(this);
                            //         // this.renderOriginal = this.renderOriginal.bind(this);
                            //         this.renderNew = this.renderNew.bind(this);
                            //     }
//
//     // testclick() {
//     //     this.setState({
//     //         clicked: !this.state.clicked
//     //     })
//     // }
//
//     renderNew() {
//         if(this.props.item["Recommended Action"] !== "N/A") {
//             return (
//                 <div className="flexRow rowmain rowWrap" >
//                     <div className="flexCell">{this.props.item.Location}</div>
//                     <div className="flexCell">{this.props.item.Notes}</div>
//                     <div className="flexCell">{this.props.item["Date Issued"]}</div>
//
//                     <div className="extratext">
//                         <div>
//                             <strong>Recomended action: </strong>{this.props.item["Recommended Action"]}
//                         </div>
//                         <div>
//                             <strong>Issue status: </strong>{this.props.item['Issue status']}
//                         </div>
//                     </div>
//                 </div>
//             )
//         } else {
//             return (
//                 <div className="flexRow rowmain rowWrap" >
//                     <div className="flexCell">{this.props.item.Location}</div>
//                     <div className="flexCell">{this.props.item.Notes}</div>
//                     <div className="flexCell">{this.props.item["Date Issued"]}</div>
//
//                 </div>
//             )
//         }
//
//
//     }
//     //
//     // renderOriginal() {
//     //     return (<div className="flexRow rowmain" >
//     //         <div className="flexCell">{this.props.item.Location}</div>
//     //         <div className="flexCell">{this.props.item.Notes}</div>
//     //         <div className="flexCell">{this.props.item["Date Issued"]}</div>
//     //     </div>);
//     // }
//
//     render() {
//         return this.renderNew()
//     }
//
// }

export default FlexRow;



// WEBPACK FOOTER //
// ./src/components/tables/FlexRow.js